import React, { useState, useRef } from 'react';
import styles from './text.module.scss';

import { withSnapPoint } from '../snapping-slider';
import { LeftGreyShard, RightGreyShard } from '@components/shards';

const TextSlide = ({ text, index, createSnapPoint, Container, slideRef }) => {
    return (
        <div ref={slideRef} className={styles.textSlide}>
            <p
                className={styles.textSlideContent}
                dangerouslySetInnerHTML={{
                    __html: text,
                }}
            />
            <LeftGreyShard />
            <RightGreyShard />
        </div>
    );
};

export default withSnapPoint(TextSlide);
